import React from 'react';

import { SVGComponentProps } from './svg.types';

const SubTask = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.36364 0C0.610521 0 0 0.610521 0 1.36364C0 2.06626 0.531406 2.64477 1.21423 2.71918V3.99992V7.63644C1.21423 8.46486 1.88581 9.13644 2.71423 9.13644H3.52319C3.72262 9.64217 4.21563 10 4.79222 10H10.6364C11.3895 10 12 9.38952 12 8.6364C12 7.88329 11.3895 7.27276 10.6364 7.27276H4.79222C4.2156 7.27276 3.72257 7.63066 3.52316 8.13644H2.71423C2.43809 8.13644 2.21423 7.91258 2.21423 7.63644V5.41457C2.37062 5.46985 2.53892 5.49993 2.71423 5.49993H3.52319C3.72262 6.00566 4.21563 6.36353 4.79222 6.36353H10.6364C11.3895 6.36353 12 5.753 12 4.99989C12 4.24677 11.3895 3.63625 10.6364 3.63625H4.79222C4.2156 3.63625 3.72257 3.99415 3.52316 4.49993H2.71423C2.43809 4.49993 2.21423 4.27607 2.21423 3.99992V2.72727H10.6364C11.3895 2.72727 12 2.11675 12 1.36364C12 0.610521 11.3895 0 10.6364 0H1.36364Z"
        fill={fill}
      />
    </svg>
  );
};

export default SubTask;
